import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wind03 = function Wind03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.7639 6.5c.5493-.6137 1.3476-1 2.2361-1 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3h-6M6.7639 4C7.3132 3.3863 8.1115 3 9 3c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3H2m8.7639 11c.5493.6137 1.3476 1 2.2361 1 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3H2"
    })
  }));
};
export default Wind03;